import React, {useCallback, useEffect, useMemo, useState} from 'react'
import Header from "../../ThemeComponents/Header";
import Footer from "../../ThemeComponents/Footer";
import Stepper from "../../ThemeComponents/ReservationPage/Stepper";
import ReservationVehicle from "../../ThemeComponents/ReservationPage/ReservationVehicle";
import ReservationLoginPanel from "../../ThemeComponents/ReservationPage/ReservationLoginPanel";
import ReservationAuthChoicePanel from "../../ThemeComponents/ReservationPage/ReservationAuthChoicePanel";
import ReservationInitLoader from "../../ThemeComponents/ReservationPage/ReservationInitLoader";
import ReservationStepNotice from "../../ThemeComponents/ReservationPage/ReservationStepNotice";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {detailVehicleAPI} from "../../network/publicCalls/GETVehicleDetail";
import {DISABLED_CACHE} from "../../config/network";
import {customerCanCreateReservation, formatPriceNl} from "../../config/toolKit";
import {getCustomersAPI} from "../../network/loggedInCalls/GETCustomers";
import {resolveWhiteLabelSubsidiaryId} from "../../config/subsidiaryId";
import {resolveWhiteLabelTheme} from "../../config/whiteLabelThemes";
import {appendPublicWrapperBaseToSearch} from "../../config/publicWrapperBase";
import {generateDemoReservationEmail, isDemoReservationLocation} from "../../config/demoReservation";
import demoLogo from "../../assets/images/demo.png";
import demoBancontact from "../../assets/images/demo/bancontact.jpg";
import demoMaestro from "../../assets/images/demo/maestro.jpg";
import demoIng from "../../assets/images/demo/ing.jpg";
import demoKbc from "../../assets/images/demo/kbc.jpg";
import demoBelfius from "../../assets/images/demo/belfius.jpg";
import demoVisa from "../../assets/images/demo/visa.jpg";
import demoMastercard from "../../assets/images/demo/mastercard.jpg";
import demoIdeal from "../../assets/images/demo/ideal.jpg";
import demoPaypal from "../../assets/images/demo/paypal.jpg";
import demoKlarna from "../../assets/images/demo/klarna.jpg";
import demoBitcoin from "../../assets/images/demo/bitcoin.jpg";
import Devider from "../../ThemeComponents/Devider";
import PriceVatToggle from "../../ThemeComponents/PriceVatToggle";
import {getPriceVatPreference, setPriceVatPreference} from "../../config/priceVatPreference";
import {forceScrollToTop} from "../../config/scrollToTop";
import {sendEvent, setUserId} from "../../config/analytics";

const DEMO_PAYMENT_METHODS = [
    {name: "Bancontact", image: demoBancontact},
    {name: "Maestro", image: demoMaestro},
    {name: "ING Home'Pay", image: demoIng},
    {name: "KBC", image: demoKbc},
    {name: "Belfius", image: demoBelfius},
    {name: "VISA", image: demoVisa},
    {name: "Mastercard", image: demoMastercard},
    {name: "iDEAL", image: demoIdeal},
    {name: "PayPal", image: demoPaypal},
    {name: "Klarna", image: demoKlarna},
    {name: "Bitcoin", image: demoBitcoin}
]

const DemoPaymentMethodsPanel = ({onNext}) => {
    return (
        <div className="kav-demo-payment-panel">
            <div className="kav-demo-payment-panel__grid">
                {
                    DEMO_PAYMENT_METHODS.map((method) => (
                        <button
                            key={method.name}
                            type="button"
                            className="kav-demo-payment-panel__method"
                            aria-label={method.name}
                        >
                            <img
                                src={method.image}
                                alt={method.name}
                                className="kav-demo-payment-panel__methodImage"
                            />
                        </button>
                    ))
                }
            </div>
            <div className="kav-demo-payment-panel__actions">
                <button
                    type="button"
                    onClick={() => {
                        if (typeof onNext === "function") {
                            onNext()
                        }
                    }}
                    className="kav-step-actions__btn kav-step-actions__btn--primary"
                >
                    Volgende
                    <i className="bi bi-chevron-right" aria-hidden="true"></i>
                </button>
            </div>
        </div>
    )
}

const CustomerAccountPanel = ({
    authToken,
    activeCustomer,
    customers,
    isLoadingCustomers,
    customerErrorMessage,
    onLogout
}) => {
    return (
        <div className="kav-panel">
            <h2 className="kav-h2">Je gegevens</h2>
            {
                isLoadingCustomers && (
                    <div className="kav-callout kav-auth-status">
                        <span className="kav-spinner" aria-hidden="true"></span>
                        <span>Je account wordt geladen...</span>
                    </div>
                )
            }

            {
                !isLoadingCustomers && customerErrorMessage && (
                    <div className="kav-callout kav-auth-error">
                        {customerErrorMessage}
                    </div>
                )
            }

            {
                activeCustomer ?
                    <>
                        <div className="kav-panel-customer-header">
                            <h2 style={{marginBottom: '10px'}} className="kav-h2">Hallo {activeCustomer.fullname}!</h2>
                            {
                                customers.length > 1 && (
                                    <select name="customers_list" className="kav-input kav-input--select">
                                        {
                                            customers.map(({id, fullname}) => {
                                                return (
                                                    <option key={id} value={id}>{fullname}</option>
                                                )
                                            })
                                        }
                                    </select>
                                )
                            }
                        </div>
                        <p className="kav-panel-customer-balance">Balans: {formatPriceNl(activeCustomer?.contract?.current_balance)}</p>
                        {
                            !customerCanCreateReservation(activeCustomer) && (
                                <div className="kav-callout kav-auth-status">
                                    <span className="kav-spinner" aria-hidden="true"></span>
                                    <span>
                                        Je account wordt momenteel goedgekeurd door support.
                                        Dit duurt meestal 1-5 minuten. We controleren de status automatisch elke 15 seconden.
                                    </span>
                                </div>
                            )
                        }
                    </>
                    :
                    !isLoadingCustomers && !customerErrorMessage && (
                        <div className="kav-callout">Geen klantprofiel gevonden voor dit account.</div>
                    )
            }
            <button
                style={{fontWeight: 400, marginTop: '10px'}}
                onClick={onLogout}
                type="button"
                className="kav-step-actions__btn kav-step-actions__btn--ghost"
            >
                Uitloggen
            </button>
        </div>
    )
}

const ReservationConfirmPage = () => {

    const {vehicleId, locationId} = useParams()
    const isDemoLocation = isDemoReservationLocation(locationId)
    const [vehicleInfo, setVehicleInfo] = useState(null)
    const [authToken, setAuthToken] = useState(null)
    const [showPricesInclVat, setShowPricesInclVat] = useState(() => getPriceVatPreference(false))
    const [customers, setCustomers] = useState([])
    const [isLoadingCustomers, setIsLoadingCustomers] = useState(false)
    const [customerErrorMessage, setCustomerErrorMessage] = useState("")

    const location = useLocation()
    const navigate = useNavigate()
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search])
    const rentalPeriod = {
        from: queryParams.get('from') || '',
        to: queryParams.get('to') || ''
    }
    const expectedKm = queryParams.get('expectedKm') || ''
    const optionsQueryRaw = queryParams.get('options') || ''
    const productsQueryRaw = queryParams.get('products') || ''
    const prefilledEmail = useMemo(() => {
        const queryEmail = String(queryParams.get('email') || '').trim()
        if (queryEmail) return queryEmail
        if (isDemoLocation) return generateDemoReservationEmail()
        return ''
    }, [queryParams, isDemoLocation])
    const registrationCompleted = queryParams.get('registered') === '1'
    const [authEmail, setAuthEmail] = useState(prefilledEmail)
    const [activeCustomer, setActiveCustomerState] = useState(null)

    // Keep the analytics user id in sync with the active customer, so later
    // sendEvent calls report the same customer id used during registration.
    // Logout (null) clears the binding in the reservation app.
    const setActiveCustomer = useCallback((customer) => {
        setActiveCustomerState(customer)
        setUserId(customer?.id ?? "")
    }, [])
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(
        registrationCompleted || queryParams.get('login') === '1'
    )
    const [isConsentModalOpen, setIsConsentModalOpen] = useState(false)
    const [consentIdChecked, setConsentIdChecked] = useState(true)
    const [consentPrivacyChecked, setConsentPrivacyChecked] = useState(true)
    const brandName = useMemo(() => resolveWhiteLabelTheme()?.logoAlt || "KAV2GO", [])
    const selectedOptionIds = (queryParams.get('options') || '')
        .split(',')
        .map((value) => value.trim())
        .filter((value) => value !== '')
        .map((value) => Number(value))
        .filter((value) => Number.isFinite(value))
    const selectedProducts = productsQueryRaw
        .split(',')
        .map((entry) => entry.trim())
        .filter(Boolean)
        .reduce((carry, entry) => {
            const [rawProductId, rawQuantity, rawDays] = entry.split(':')
            const productId = Number(rawProductId)
            const quantity = Number(rawQuantity)
            const days = Number(rawDays)
            if (!Number.isFinite(productId) || productId <= 0) return carry
            if (!Number.isFinite(quantity) || quantity <= 0) return carry
            carry[productId] = {
                quantity: Math.floor(quantity),
                days: Number.isFinite(days) && days > 0 ? Math.floor(days) : null
            }
            return carry
        }, {})

    const hasVehicleExtras = vehicleInfo
        ? (
            (Array.isArray(vehicleInfo.options) && vehicleInfo.options.length > 0) ||
            (Array.isArray(vehicleInfo.products) && vehicleInfo.products.length > 0)
        )
        : true
    const stepperSteps = hasVehicleExtras
        ? ['Huurperiode', 'Opties', 'Je gegevens']
        : ['Huurperiode', 'Je gegevens']

    useEffect(() => {
        forceScrollToTop()
    }, [location.pathname])

    useEffect(() => {
        sendEvent("reserve_confirm_view")
    }, [])

    useEffect(() => {
        if (vehicleId) {
            (async () => {
                const vehicleResponse = await detailVehicleAPI({vehicleId, force: DISABLED_CACHE})
                setVehicleInfo(vehicleResponse)
            })()
        }
    }, [vehicleId]);

    const subsidiaryId = useMemo(() => {
        if (!vehicleInfo) return null
        const defaultSubsidiaryId = vehicleInfo.company.parent ? vehicleInfo.company.parent.id : vehicleInfo.company.id
        return resolveWhiteLabelSubsidiaryId(defaultSubsidiaryId)
    }, [vehicleInfo])

    const fetchCustomers = useCallback(async () => {
        if (!authToken || !subsidiaryId) return

        setIsLoadingCustomers(true)
        setCustomerErrorMessage("")

        try {
            const customersResponse = await getCustomersAPI({authToken, subsidiaryId})
            setCustomers(customersResponse || [])
        } catch (ex) {
            setCustomerErrorMessage("We konden je accountgegevens niet laden. Probeer opnieuw in te loggen.")
        } finally {
            setIsLoadingCustomers(false)
        }
    }, [authToken, subsidiaryId])

    useEffect(() => {
        fetchCustomers()
    }, [fetchCustomers])

    useEffect(() => {
        if (!Array.isArray(customers)) return

        const privateCustomer = customers.find(({type}) => type === 'private')
        if (privateCustomer) {
            setActiveCustomer(privateCustomer)
            return
        }

        if (customers.length > 0) {
            setActiveCustomer(customers[0])
            return
        }

        setActiveCustomer(null)
    }, [customers]);

    useEffect(() => {
        if (!authToken || !subsidiaryId) return
        if (customerCanCreateReservation(activeCustomer)) return

        const intervalId = setInterval(() => {
            fetchCustomers()
        }, 15000)

        return () => {
            window.clearInterval(intervalId)
        }
    }, [authToken, subsidiaryId, activeCustomer, fetchCustomers])

    const onLogout = () => {
        if (typeof window !== "undefined" && window.localStorage) {
            window.localStorage.removeItem("token")
        }
        setAuthToken(null)
        setActiveCustomer(null)
        setCustomers([])
    }

    useEffect(() => {
        if (typeof window === "undefined") return
        const persistedToken = window.localStorage.getItem("token")
        if (persistedToken) {
            setAuthToken(persistedToken)
        }
    }, [])

    const buildReservationSearch = (extraParams = {}) => appendPublicWrapperBaseToSearch(new URLSearchParams({
        from: rentalPeriod.from || "",
        to: rentalPeriod.to || "",
        expectedKm: expectedKm || "",
        options: optionsQueryRaw || "",
        products: productsQueryRaw || "",
        ...extraParams,
    }), location.search).toString()

    const onOpenConsentModal = () => {
        setConsentIdChecked(true)
        setConsentPrivacyChecked(true)
        setIsConsentModalOpen(true)
    }

    // Consent is confirmed here so the registration page can start at the account step directly.
    const onRegisterConsentConfirm = () => {
        if (!consentIdChecked || !consentPrivacyChecked) return
        setIsConsentModalOpen(false)
        navigate({
            pathname: `/reservation-register/${vehicleId}/${locationId}`,
            search: buildReservationSearch({consent: "1"}),
        })
    }

    const onChangeRentalParams = () => {
        navigate({
            pathname: `/reservation/${vehicleId}/${locationId}`,
            search: buildReservationSearch(),
        })
    }

    const [demoPaymentStepLocked, setDemoPaymentStepLocked] = useState(false)
    const [demoPaymentFinished, setDemoPaymentFinished] = useState(false)
    const [demoPaymentAmount, setDemoPaymentAmount] = useState(null)
    const [isDemoPaymentModalOpen, setIsDemoPaymentModalOpen] = useState(false)
    const [isDemoPaymentProcessing, setIsDemoPaymentProcessing] = useState(false)
    const canShowDemoPaymentStep = isDemoLocation && (
        demoPaymentStepLocked || (Boolean(authToken) && Boolean(activeCustomer))
    )
    const showDemoPaymentStep = canShowDemoPaymentStep && !demoPaymentFinished
    const showDemoPostPaymentStep = isDemoLocation && demoPaymentFinished
    const handlePriceVatPreferenceChange = (nextShowPricesInclVat) => {
        setShowPricesInclVat(nextShowPricesInclVat)
        setPriceVatPreference(nextShowPricesInclVat)
    }

    useEffect(() => {
        if (!isDemoLocation) {
            setDemoPaymentStepLocked(false)
            setDemoPaymentFinished(false)
            return
        }
        if (authToken && activeCustomer) {
            setDemoPaymentStepLocked(true)
        }
    }, [isDemoLocation, authToken, activeCustomer])

    useEffect(() => {
        if (!isDemoLocation) return
        if (!authToken) {
            if (typeof window !== "undefined") {
                const persistedToken = window.localStorage.getItem("token")
                if (persistedToken) return
            }
            setDemoPaymentStepLocked(false)
            setDemoPaymentFinished(false)
        }
    }, [isDemoLocation, authToken])

    useEffect(() => {
        if (!showDemoPaymentStep) {
            setIsDemoPaymentModalOpen(false)
            setIsDemoPaymentProcessing(false)
        }
    }, [showDemoPaymentStep])

    return (
        <>
            <Header/>
            <Devider />

            <div className="container mt-5 kav-reservation-top">
                {
                    isDemoLocation ? (
                        <div className="kav-reservation-top__demoLogoWrap" aria-hidden="true">
                            <img src={demoLogo} alt="" className="kav-reservation-top__demoLogo"/>
                        </div>
                    ) : null
                }
                <div className="row">
                    <div className="col-md-4 front-reservation-promo">
                        <h1>Reserveren</h1>
                        {/*<p>Binnen 1 minuut in {stepperSteps.length} eenvoudige stappen.</p>*/}
                    </div>
                    <div className="col-md-4">
                        <Stepper steps={stepperSteps} current={hasVehicleExtras ? 2 : 1}/>
                    </div>
                </div>
                {
                    !activeCustomer ? (
                        <div className="row">
                            <div className="col-12">
                                <ReservationStepNotice
                                    step={`Stap ${stepperSteps.length === 2 ? "2" : "3"}`}
                                    mixed
                                >
                                    <span className="kav-demo-step-banner__strong">Al klant? Meld je aan met je email en wachtwoord.</span>{" "}
                                    <span>Nog geen klant? Dan doen we een rijbewijscheck. Dit doen we met de smartphone. Hiervoor is ook een geldig rijbewijs nodig.</span>
                                </ReservationStepNotice>
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            <div className="col-12">
                                <ReservationStepNotice step={`Stap ${stepperSteps.length === 2 ? "3" : "4"}`}>
                                    Bestelling voldoen inclusief Borg.
                                </ReservationStepNotice>
                            </div>
                        </div>
                    )
                }

                {
                    isDemoLocation ? (
                        <div className="row">
                            <div className="col-12">
                                <div className="kav-demo-step-banner">
                                    {
                                        showDemoPaymentStep ? (
                                            <>
                                                <span className="kav-demo-step-banner__badge">Stap 8</span>
                                                <p className="kav-demo-step-banner__mixedText">
                                                    <span className="kav-demo-step-banner__strong">Hier gaat de klant betalen voor de rit, de eventuele accessoires en de borg</span>{' '}
                                                    <span>(dit is nu virtueel, druk op de knop 'volgende' en de borg is automatisch toegevoegd)</span>
                                                </p>
                                            </>
                                        ) : showDemoPostPaymentStep ? (
                                            <>
                                                <span className="kav-demo-step-banner__badge">Stap 9</span>
                                                <p className="kav-demo-step-banner__mixedText">
                                                    <span className="kav-demo-step-banner__strong">De betaling is geslaagd. Het virtuele tegoed is €9999,00 euro.</span>{' '}
                                                    <span>Hiermee kunt u en uw collega&apos;s de demo voertuigen reserveren en vastleggen. Als u op bevestig boeking klikt ontvangt u een email met alle boekingsdetails</span>
                                                </p>
                                            </>
                                        ) : registrationCompleted ? (
                                            <>
                                                <span className="kav-demo-step-banner__badge">Stap 7</span>
                                                <p className="kav-demo-step-banner__mixedText">
                                                    <span className="kav-demo-step-banner__strong">Uw account is succesvol aangemaakt!</span>{' '}
                                                    <span>Gebruik uw gegevens om in te loggen.</span>
                                                </p>
                                            </>
                                        ) : (
                                            <>
                                                <span className="kav-demo-step-banner__badge">Stap 4</span>
                                                <p className="kav-demo-step-banner__mixedText">
                                                    <span className="kav-demo-step-banner__strong">Inloggen</span>{' '}
                                                    <span>(bestaande klant)</span>{' '}
                                                    <span className="kav-demo-step-banner__strong">of Aanmelden</span>{' '}
                                                    <span>(Rijbewijs– en persoon checks)</span>
                                                </p>
                                            </>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    ) : null
                }
            </div>

            <div className="container mt-5 mb-5">
                {vehicleInfo ? (
                    <div className="row">
                        { authToken && (<div className="col-12">
                            <PriceVatToggle
                                showPricesInclVat={showPricesInclVat}
                                onChange={handlePriceVatPreferenceChange}
                            />
                        </div>) }
                        {
                            !authToken && !showDemoPaymentStep ? (
                                <div className="col-12">
                                    <ReservationAuthChoicePanel
                                        brandName={brandName}
                                        onLogin={() => setIsLoginModalOpen(true)}
                                        onRegister={onOpenConsentModal}
                                        onChangeRentalParams={onChangeRentalParams}
                                    />
                                </div>
                            ) : (
                                <>
                                    <div className={`col-md-6 ${showDemoPaymentStep ? "order-md-2" : ""}`}>
                                        {
                                            showDemoPaymentStep ? (
                                                <DemoPaymentMethodsPanel
                                                    onNext={() => setIsDemoPaymentModalOpen(true)}
                                                />
                                            ) : (
                                                <CustomerAccountPanel
                                                    authToken={authToken}
                                                    activeCustomer={activeCustomer}
                                                    customers={customers}
                                                    isLoadingCustomers={isLoadingCustomers}
                                                    customerErrorMessage={customerErrorMessage}
                                                    onLogout={onLogout}
                                                />
                                            )
                                        }
                                    </div>

                                    <div className={`col-md-6 ${showDemoPaymentStep ? "order-md-1" : ""}`}>
                                        <ReservationVehicle
                                            vehicleInfo={vehicleInfo}
                                            rentalPeriod={rentalPeriod}
                                            expectedKm={expectedKm}
                                            selectedOptions={selectedOptionIds}
                                            selectedProducts={selectedProducts}
                                            locationId={locationId}
                                            showDeposit={true}
                                            activeCustomer={activeCustomer}
                                            authToken={authToken}
                                            demoVirtualCheckout={showDemoPostPaymentStep}
                                            hideActionButtons={showDemoPaymentStep}
                                            onDemoPaymentAmountChange={(amount) => setDemoPaymentAmount(amount)}
                                            showPricesInclVat={showPricesInclVat}
                                            onCustomerChanged={fetchCustomers}
                                        />
                                    </div>
                                </>
                            )
                        }
                    </div>
                ) : (
                    <ReservationInitLoader />
                )}
            </div>

            {
                !authToken && isLoginModalOpen && (
                    <div className="kav-simple-modal" role="dialog" aria-modal="true" aria-label="Inloggen">
                        <button
                            type="button"
                            className="kav-simple-modal__backdrop"
                            onClick={() => setIsLoginModalOpen(false)}
                            aria-label="Sluiten"
                        />
                        <div className="kav-simple-modal__card kav-auth-modal">
                            <button
                                type="button"
                                className="kav-simple-modal__close"
                                onClick={() => setIsLoginModalOpen(false)}
                                aria-label="Sluiten"
                            >
                                <i className="bi bi-x" aria-hidden="true"></i>
                            </button>
                            <ReservationLoginPanel
                                subsidiaryId={subsidiaryId}
                                onAuthSuccess={(token) => {
                                    setIsLoginModalOpen(false)
                                    setAuthToken(token)
                                }}
                                email={authEmail}
                                onEmailChange={setAuthEmail}
                                showRegistrationSuccess={registrationCompleted}
                                embedded
                            />
                        </div>
                    </div>
                )
            }

            {
                !authToken && isConsentModalOpen && (
                    <div className="kav-simple-modal" role="dialog" aria-modal="true" aria-label="Account aanmaken">
                        <button
                            type="button"
                            className="kav-simple-modal__backdrop"
                            onClick={() => setIsConsentModalOpen(false)}
                            aria-label="Sluiten"
                        />
                        <div className="kav-simple-modal__card">
                            <h3>Account aanmaken</h3>
                            <label className="kav-register-mobile__check">
                                <input
                                    type="checkbox"
                                    checked={consentIdChecked}
                                    onChange={(event) => setConsentIdChecked(event.target.checked)}
                                />
                                <span>Ik verklaar dat mijn geuploade ID echt is.</span>
                            </label>
                            <label className="kav-register-mobile__check">
                                <input
                                    type="checkbox"
                                    checked={consentPrivacyChecked}
                                    onChange={(event) => setConsentPrivacyChecked(event.target.checked)}
                                />
                                <span>Ik ga akkoord met de verwerking van mijn persoonsgegevens.</span>
                            </label>
                            <div className="kav-auth-actions kav-auth-actions--mobile-reverse">
                                <button
                                    type="button"
                                    className="kav-step-actions__btn kav-step-actions__btn--primary"
                                    disabled={!consentIdChecked || !consentPrivacyChecked}
                                    onClick={onRegisterConsentConfirm}
                                >
                                    Bevestigen
                                </button>
                                <button
                                    type="button"
                                    className="kav-step-actions__btn kav-step-actions__btn--ghost"
                                    onClick={() => setIsConsentModalOpen(false)}
                                >
                                    Annuleren
                                </button>
                            </div>
                            <p className="kav-register-mobile__help">
                                Vragen? Bel ons op <a href="tel:+31880883434">+31 88 088 3434</a>
                            </p>
                        </div>
                    </div>
                )
            }

            {
                isDemoLocation && showDemoPaymentStep && isDemoPaymentModalOpen && (
                    <div className="kav-simple-modal" role="dialog" aria-modal="true">
                        <button
                            type="button"
                            className="kav-simple-modal__backdrop"
                            onClick={() => {
                                if (isDemoPaymentProcessing) return
                                setIsDemoPaymentModalOpen(false)
                            }}
                            aria-label="Sluiten"
                        />
                        <div className="kav-simple-modal__card">
                            <h3>Betaling reservering</h3>
                            <p>
                                Om verder te gaan met je reservering moet je eerst de betaling afronden.
                            </p>
                            <div className="kav-callout">
                                Te betalen bedrag: <span className="kav-callout__strong">{demoPaymentAmount !== null ? formatPriceNl(demoPaymentAmount) : "--"}</span>
                            </div>
                            <div className="kav-auth-actions">
                                <button
                                    type="button"
                                    className="kav-step-actions__btn kav-step-actions__btn--ghost"
                                    onClick={() => setIsDemoPaymentModalOpen(false)}
                                    disabled={isDemoPaymentProcessing}
                                >
                                    Annuleren
                                </button>
                                <button
                                    type="button"
                                    className="kav-step-actions__btn kav-step-actions__btn--primary"
                                    disabled={isDemoPaymentProcessing}
                                    onClick={() => {
                                        if (isDemoPaymentProcessing) return
                                        setIsDemoPaymentProcessing(true)
                                        window.setTimeout(() => {
                                            setIsDemoPaymentProcessing(false)
                                            setIsDemoPaymentModalOpen(false)
                                            setDemoPaymentFinished(true)
                                        }, 2200)
                                    }}
                                >
                                    {isDemoPaymentProcessing && <span className="kav-spinner kav-spinner--light" aria-hidden="true"></span>}
                                    {isDemoPaymentProcessing ? "Betaling verwerken..." : "Betalen"}
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }

            <Footer/>
        </>
    )
}

export default ReservationConfirmPage
